var $75bc5191b9d7826a$exports = {};
$75bc5191b9d7826a$exports = {
  "close": "Sule",
  "notifications": function notifications(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      one: function one() {
        return "".concat(formatter.number(args.count), " teatis");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " teatist");
      }
    }), ".");
  }
};
export { $75bc5191b9d7826a$exports as default };